export default {
    ALL: 'ALL'
};
